/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_QUESTION } from "./actionTypes"
import { apiError, editQuestionSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updateQuestion } from "../../../helpers/backend_helper"

function* edit(request) {
  try {
    const response = yield call(updateQuestion, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(editQuestionSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* questionEditSaga() {
  yield takeEvery(EDIT_QUESTION, edit)
}

export default questionEditSaga
